import { OpenIdConfiguration } from 'angular-auth-oidc-client';

const auth: OpenIdConfiguration = {
    unauthorizedRoute: '/auth/unauthorized',
    redirectUrl: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    clientId: 'eHtWyI5nlc7HPH5ihRRWCyyFD4TSPmT4',
    authority: 'https://shs.login-qa.siemens-healthineers.com',
    authWellknownEndpointUrl: 'https://shs.login-qa.siemens-healthineers.com/.well-known/openid-configuration',
    scope: 'openid profile email offline_access',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    autoUserInfo: false,
    renewTimeBeforeTokenExpiresInSeconds: 300,
    maxIdTokenIatOffsetAllowedInSeconds: 600,
    renewUserInfoAfterTokenRenew: true,
    ignoreNonceAfterRefresh: true,
    authWellknownEndpoints: {
        userInfoEndpoint: 'https://shs-qa-001-001.eu.auth0.com/userinfo',
        authorizationEndpoint: 'https://shs.login-qa.siemens-healthineers.com/authorize',
        tokenEndpoint: 'https://shs.login-qa.siemens-healthineers.com/oauth/token',
        jwksUri: 'https://shs.login-qa.siemens-healthineers.com/.well-known/jwks.json',
        revocationEndpoint: 'https://shs.login-qa.siemens-healthineers.com/oauth/revoke',
        issuer: 'https://shs.login-qa.siemens-healthineers.com/'
    },
    historyCleanupOff: false,
    useCustomAuth0Domain: true
};

export const environment = {
    production: true,
    auth: {
        ...auth,
        isConfigured: Boolean(auth.authority && auth.clientId)
    },
    apiUrls: {
        supplier: 'https://api.dev.sidex-inspect.siemens-healthineers.com/v1/supplier',
        order: 'https://api.dev.sidex-inspect.siemens-healthineers.com/v1/supplier/orders'
    }
};
